import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const EyeHideIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.01" y="0.919922" width="20.3782" height="19.3835" fill="#1E2329" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.22923 12.0122C3.8237 15.2711 6.69758 16.9006 9.85086 16.9006C13.0041 16.9006 15.878 15.2711 18.4725 12.0122C18.798 11.6035 18.798 11.0217 18.4725 10.613C15.878 7.35407 13.0041 5.72461 9.85086 5.72461C6.69758 5.72461 3.8237 7.35407 1.22923 10.613C0.903734 11.0217 0.903734 11.6035 1.22923 12.0122ZM17.6077 11.3126C15.2094 14.3245 12.6383 15.783 9.85086 15.783C7.06346 15.783 4.49227 14.3245 2.09405 11.3126C4.49227 8.30068 7.06346 6.84221 9.85086 6.84221C12.6383 6.84221 15.2094 8.30068 17.6077 11.3126Z"
        fill="#6C717F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.97029 12.9901C7.56447 14.0275 8.66255 14.6665 9.8509 14.6665C11.6879 14.6665 13.1771 13.1654 13.1771 11.3137C13.1771 9.46204 11.6879 7.96094 9.8509 7.96094C8.66255 7.96094 7.56447 8.59998 6.97029 9.63734C6.37611 10.6747 6.37611 11.9528 6.97029 12.9901ZM12.0684 11.3137C12.0684 12.5482 11.0756 13.5489 9.8509 13.5489C8.62621 13.5489 7.63341 12.5482 7.63341 11.3137C7.63341 10.0793 8.62621 9.07854 9.8509 9.07854C11.0756 9.07854 12.0684 10.0793 12.0684 11.3137Z"
        fill="#6C717F"
      />
      <path
        d="M6.48901 19.427C6.34809 19.6935 6.02264 19.7989 5.7541 19.6651C5.48556 19.5312 5.37107 19.2066 5.49557 18.9319L13.2213 3.20284C13.3084 3.02252 13.4847 2.90308 13.6833 2.88989C13.8818 2.87669 14.0722 2.97176 14.182 3.13899C14.2918 3.30622 14.3043 3.51996 14.2148 3.69905L6.48901 19.427Z"
        fill="#6C717F"
      />
    </svg>
  </span>
);

export default EyeHideIcon;
